import styled from 'styled-components';

export const MobileComponentWrapper = styled.div`
  display: none;
  flex-direction: column;
  margin-top: 12px;

  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
  }
`;
